<template>
  <b-dropdown
    size="md"
    variant="link"
    toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-xs btn-icon"
    no-caret
    right
    no-flip
  >
    <template v-slot:button-content>
      <i class="flaticon2-printer icon-lg"></i>
    </template>
    <div class="navi navi-hover min-w-md-250px">
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" @click="edit(id)">
          <span class="navi-icon"><i class="fas fa-edit"></i></span>
          <span class="navi-text">Edit</span>
        </a>
        <a href="#" class="navi-link" @click="waybill(id)">
          <span class="navi-icon"><i class="fas fa-receipt"></i></span>
          <span class="navi-text">Print waybill</span>
        </a>
        <a href="#" class="navi-link" @click="ecommerce(id)">
          <span class="navi-icon"><i class="fas fa-qrcode"></i></span>
          <span class="navi-text">Print QR label</span>
        </a>
      </b-dropdown-text>
    </div>
  </b-dropdown>
</template>

<script>
import { getWaybill, getECommerceLabel } from "@/api/job.api";

export default {
  props: {
    id: Number
  },
  setup(_, context) {
    // const id = props.id;
    const edit = id => {
      context.root.$router.push({ name: "UpdateJob", params: { id: id } }).catch(() => {
        context.root.$router.push({ name: "UpdateJob", params: { id: id } });
      });
    };

    const waybill = id => {
      getWaybill(id).then(response => {
        const newBlob = new Blob([response.data], { type: "application/pdf" });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement("a");
        link.href = data;
        link.download = `${id}.pdf`;
        link.click();
        setTimeout(function() {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      });
    };

    const ecommerce = id => {
      getECommerceLabel(id).then(response => {
        const newBlob = new Blob([response.data], { type: "application/pdf" });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement("a");
        link.href = data;
        link.download = `${id}.pdf`;
        link.click();
        setTimeout(function() {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      });
    };

    return {
      edit,
      waybill,
      ecommerce
    };
  }
};
</script>
